import { Order } from "@/types/order";
import React from "react";
import { TableView } from "..";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import ItemDetails from "./item-details";
import OrderDetails from "./order-details";
import { OrderItemWithCurrency } from "../items-table/hooks";

interface SideBarProps {
  isOpen: boolean;
  data: Order | OrderItemWithCurrency | undefined;
  onClose: () => void;
  view: TableView;
}

const SideBar: React.FC<SideBarProps> = ({ isOpen, data, onClose, view }) => {
  return (
    <>
      <div
        className={`${isOpen ? "block" : "hidden"} fixed inset-0 bg-black/20 z-40`}
        onClick={onClose}
      />
      <div
        className={`
        fixed top-0 right-0 h-full w-96 bg-white shadow-lg z-50 transform
        transition-transform duration-300
        ${isOpen ? "translate-x-0" : "translate-x-full"}
      `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-semibold mb-0">
            {view === "orders" ? "Order details" : "Item details"}
          </h2>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X />
          </Button>
        </div>
        <div className="p-6">
          {data ? (
            view === "orders" ? (
              <OrderDetails order={data as Order} />
            ) : (
              <ItemDetails item={data as OrderItemWithCurrency} />
            )
          ) : (
            <p>No {view === "orders" ? "order" : "item"} selected.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default SideBar;
